module.exports = __webpack_public_path__ + "img/circle-question.1ab81224.svg";